import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  HostBinding,
} from "@angular/core";
import { IUProperty } from "src/app/shared/interface/umbraco-property";
import { IPanelSettings } from "src/app/shared/interface/panel-settings";
import { resolveThemeCssClass } from "../lib/helper/panel-settings";
import { IPictureData } from "../lib/public_api";
import { IRteStyleSettings } from '../../shared/interface/rte-style-settings';
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';
import { ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';

interface InfoCardPanelData {
  title?: IUProperty<string>;
  description?: IUProperty<string>;
  panelSettings?: IPanelSettings;
  backgroundColor?: IUProperty<string>;
  ordering?: IUProperty<string>;
  backgroundImage?: IUProperty<IPictureData>;
  media: any;

  titleStyleSettings?: ITitleStyleSettings;
  rteStyleSettings?: IRteStyleSettings;
}

enum isReversedEnum {
  Has = "Title - Image - Text",
  No = "Title - Text - Image",
}

@Component({
  selector: "app-info-card-panel",
  templateUrl: "./info-card-panel.component.html",
  styleUrls: ["./info-card-panel.component.less"],
})
export class InfoCardPanelComponent implements OnInit {
  @Input() data: InfoCardPanelData;
  @ViewChild("titleEl", { static: false }) titleEl: ElementRef<HTMLElement>;
  @ViewChild('descriptionEl', { static: false }) descriptionEl: ElementRef<HTMLElement>;
  @ViewChild("panelElRef", { static: false })
  panelElRef: ElementRef<HTMLElement>;
  @HostBinding("class") get hostClasses() {
    return resolveThemeCssClass(this.data.panelSettings);
  }
  public isReversed = false;
  public hasImage: boolean;
  public media: any;

  constructor(private hostRef: ElementRef) {}

  ngOnInit() {
    if (this.data) {
      this.isReversed = isReversedEnum.Has === this.data.ordering.value;
      this.prepareMedia();
    }
  }

  ngAfterViewInit(): void {
    this.setCustomThemeProperties(this.data);
  }

  private setCustomThemeProperties(d: InfoCardPanelData) {
    applyRteSettings(this.data, this.descriptionEl);
    applyTitleSettings(this.data, this.titleEl);

    if (d.backgroundColor && d.backgroundColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--info-background-color",
        d.backgroundColor.value
      );
    }

    if (
      this.panelElRef &&
      this.panelElRef.nativeElement &&
      this.data &&
      this.data.backgroundImage &&
      this.data.backgroundImage.value
    ) {
      this.panelElRef.nativeElement.style.backgroundImage =
        "url(" + this.data.backgroundImage.value.src + ")";
      this.panelElRef.nativeElement.style.backgroundSize = "cover";
      this.panelElRef.nativeElement.style.backgroundRepeat = "no-repeat";
    }
  }

  private prepareMedia() {
    try {
      if (!this.data || !this.data.media || !this.data.media.value) return;

      const media = this.data.media.value;

      this.hasImage = !!media.image;

      if (this.hasImage) {
        this.media = media.image;
      } else {
        this.media = {
          desktop: media.video.desktop || media.video.mobile,
          mobile: media.video.mobile || media.video.desktop,
        };
      }
    } catch (err) {
      console.error("TODO: fix it please");
    }
  }
}
